import { Dispatch, SetStateAction, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useOnClickOutside } from '../../helpers/helperFunctions';
import { HELPDESK_QUESTION } from '../../routes/routes';
import { SearchDropdownQuestion, SearchDropdownStyle } from './HelpDeskStyled';
import { Category, Question } from './helpDesk.types';

interface SearchDropdownPropsType {
  questions: Question[];
  category: Category | null;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const SearchDropdown = ({
  questions,
  category,
  isOpen,
  setIsOpen
}: SearchDropdownPropsType) => {
  const { t } = useTranslation('helpdesk');
  const history = useHistory();
  const ref = useRef(null);
  useOnClickOutside(ref, () => isOpen && setIsOpen(false));

  return (
    <>
      {isOpen ? (
        <SearchDropdownStyle ref={ref}>
          {questions?.length > 0 ? (
            questions?.map((question, i) => (
              <SearchDropdownQuestion
                key={i}
                onClick={() => {
                  history.push(
                    `${HELPDESK_QUESTION}/${question.id}/${category?.id}`
                  );
                }}>
                {question.question}
              </SearchDropdownQuestion>
            ))
          ) : (
            <div style={{ marginBottom: 15 }}>{t('nothing_found')}</div>
          )}
        </SearchDropdownStyle>
      ) : (
        <></>
      )}
    </>
  );
};
